import { render } from "./TanlovFanlar.vue?vue&type=template&id=556ce6c1&scoped=true"
import script from "./TanlovFanlar.vue?vue&type=script&lang=js"
export * from "./TanlovFanlar.vue?vue&type=script&lang=js"

import "./TanlovFanlar.vue?vue&type=style&index=0&id=556ce6c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556ce6c1"]])

export default __exports__